module.exports = require("events");


//////////////////
// WEBPACK FOOTER
// external "events"
// module id = 30
// module chunks = 0